import { useRef, useState } from "react";

/**
 * Triggers file pick → uploads via uploadFn → calls onUploaded(url).
 * uploadFn should return { success, url } (same shape as API upload responses).
 */
const BackblazeUploadButton = ({
  accept,
  uploadFn,
  onUploaded,
  onError,
  label = "Upload to Backblaze",
  busyLabel = "Uploading…",
  className = "",
  disabled = false,
  folder,
}) => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handleChange = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const res = await uploadFn(file, folder);
      if (res?.success && res.url) {
        onUploaded(res.url);
      } else {
        onError?.(res?.message || "Upload failed");
      }
    } catch (err) {
      onError?.(err?.response?.data?.message || err.message || "Upload failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        className="hidden"
        onChange={handleChange}
        disabled={disabled || busy}
      />
      <button
        type="button"
        disabled={disabled || busy}
        onClick={() => inputRef.current?.click()}
        className={
          className ||
          "text-footnote-semibold px-3 py-1.5 rounded-radius-xs border border-accent-default text-accent-text hover:bg-accent-tinted transition disabled:opacity-50"
        }
      >
        {busy ? busyLabel : label}
      </button>
    </>
  );
};

export default BackblazeUploadButton;
